export default "__VITE_ASSET__66d02b66__"